import { render, staticRenderFns } from "./IntrestedPartnerDetails.vue?vue&type=template&id=221c1d1a&scoped=true&"
import script from "./IntrestedPartnerDetails.vue?vue&type=script&lang=js&"
export * from "./IntrestedPartnerDetails.vue?vue&type=script&lang=js&"
import style0 from "./IntrestedPartnerDetails.vue?vue&type=style&index=0&id=221c1d1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221c1d1a",
  null
  
)

export default component.exports